import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import Input from '../../../../components/elements/input/Input';
import { resetAdminPin } from '../../api/adminsApi';
import { ADMIN_PIN_PATTERN, onlyPinDigits } from '../../utils/adminUsername';
import { formatUsername } from '../../../../shared/utils/roles';

const ResetAdminPinModal = ({ isOpen, onClose, admin }) => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setPin('');
    setLoading(false);
    setDone(false);
    setError('');
    setSuccessMessage('');
  }, [isOpen]);

  const handleOk = useCallback(async () => {
    if (!admin?._id) return;
    if (!ADMIN_PIN_PATTERN.test(pin)) {
      setError('PIN mora imati tačno 5 cifara.');
      return;
    }

    setLoading(true);
    setError('');

    const response = await resetAdminPin(admin._id, pin);

    if (!response.ok) {
      setError(response.message);
      setLoading(false);
      return;
    }

    setSuccessMessage(response.message);
    setDone(true);
    setLoading(false);

    setTimeout(() => {
      setDone(false);
      onClose();
    }, 1200);
  }, [admin?._id, pin, onClose]);

  return (
    <Modal
      className="create_user_modal"
      title="Resetuj PIN"
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Ponisti
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleOk}
          disabled={loading || done}
        >
          {loading ? (
            <img
              src="/assets/icons/add.svg"
              alt="Učitavanje"
              className="animate-spin"
            />
          ) : done ? (
            <img
              src="/assets/icons/check.svg"
              alt="Gotovo"
              className="check-icon"
            />
          ) : (
            'Sačuvaj PIN'
          )}
        </Button>,
      ]}
    >
      <p>
        Unesite novi PIN za admina{' '}
        <strong>
          {[admin?.firstName, admin?.lastName].filter(Boolean).join(' ')}
        </strong>{' '}
        ({formatUsername(admin?.username)}). Postojeće prijave tog naloga
        prestaju da važe.
      </p>
      <div className="create_user_modal_form" autoComplete="off">
        <Input
          required
          label="Novi PIN (5 cifara)"
          id="adminNewPin"
          name="pin"
          type="password"
          inputMode="numeric"
          placeholder="Novi PIN (5 cifara)"
          autoComplete="new-password"
          value={pin}
          onChange={(e) => setPin(onlyPinDigits(e.target.value))}
        />
        {successMessage && (
          <Alert
            title={successMessage}
            type="success"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        {error && (
          <Alert
            title={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </div>
    </Modal>
  );
};

ResetAdminPinModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  admin: PropTypes.shape({
    _id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    username: PropTypes.string,
  }),
};

export default ResetAdminPinModal;
